import React, { useState } from 'react';
import { Modal, Button, Alert, Table } from 'react-bootstrap';
import { IContactForList } from '@nkr/models/index';

interface IProps {
    show: boolean;
    data: IContactForList | null;
    isCenter: boolean;
    onDelete: () => void;
    onCancel: () => void;
}

const HardDelete: React.FC<IProps> = ({ show, data, isCenter, onDelete, onCancel }) => {
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleSubmit = () => {
        if (showConfirmation == false) {
            setShowConfirmation(true);
        } else {
            setShowConfirmation(false);
            onDelete();
        }
    }

    let fullName = data != null ? data.firstName + ' ' + data.lastName : '';
    let email = data != null ? data.email : '';
    let entityTypeName = data != null ? data.entityTypeName : '';

    return (
        <Modal show={show} backdrop='static' keyboard={false} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Hard Delete Contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' bsSize='sm'>
                    <strong>Warning:</strong> This action will permanently delete the contact and cannot be undone.
                </Alert>

                <p>
                    Are you sure you want to permanently delete the contact <strong>{fullName}</strong>?
                </p>

                <Table bordered condensed>
                    <tbody>
                        <tr>
                            <td style={{ fontWeight: 'bold' }}>Email:</td>
                            <td>{email}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: 'bold' }}>Entity Type:</td>
                            <td>{entityTypeName}</td>
                        </tr>
                    </tbody>
                </Table>

                <p>
                    This action will remove all associated data and cannot be recovered.
                </p>

                {showConfirmation &&
                    <Alert bsStyle='danger' bsSize='sm'>
                        To confirm the PERMANENT deletion of this contact, click <strong>Confirm Permanent Deletion</strong> below.
                    </Alert>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle={!showConfirmation ? 'primary' : 'danger'} onClick={handleSubmit}>
                    {!showConfirmation ? 'Permanently Delete' : 'Confirm Permanent Deletion'}
                </Button>
                <Button onClick={onCancel}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default HardDelete;